import { t } from '../src';

export default {
  methods: {
    t(...args) {
      return t.apply(this, args);
    }
  }
};
